export default "__VITE_ASSET__62d48573__"